(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2424],{

/***/ 4028:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/[bid]",
      function () {
        return __webpack_require__(8972);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 1320:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SharePopup; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8029);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7294);
/* harmony import */ var react_icons_io5__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(155);
/* harmony import */ var react_icons_md__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5434);






function SharePopup(param) {
    var isOpen = param.isOpen, onClose = param.onClose;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(""), currentUrl = ref[0], setCurrentUrl = ref[1];
    var ref1 = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .useClipboard */ .VPI)(currentUrl), hasCopied = ref1.hasCopied, onCopy = ref1.onCopy;
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        if (true) {
            setCurrentUrl(window.location.href);
        }
    }, []);
    var facebookURL = "https://www.facebook.com/sharer/sharer.php?u=".concat(currentUrl);
    var whatsAppURL = "https://api.whatsapp.com/send?text=".concat(encodeURIComponent(currentUrl));
    var handleFacebookShare = function() {
        if (true) {
            window.open(facebookURL, "_blank");
        }
    };
    var handleWhatsAppShare = function() {
        if (true) {
            window.open(whatsAppURL, "_blank");
        }
    };
    if (!isOpen) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xuv, {
        position: "fixed",
        top: "0",
        left: "0",
        width: "100vw",
        height: "100vh",
        bg: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: "9999",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xuv, {
            bg: "white",
            borderRadius: "md",
            p: 6,
            maxWidth: "400px",
            width: "90%",
            position: "relative",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zxk, {
                    position: "absolute",
                    top: 2,
                    right: 2,
                    onClick: onClose,
                    variant: "ghost",
                    size: "sm",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_io5__WEBPACK_IMPORTED_MODULE_4__/* .IoClose */ .bjh, {})
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xvT, {
                    fontSize: "lg",
                    fontWeight: "bold",
                    mb: 4,
                    children: "Share this page"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kCb, {
                    gap: 3,
                    mb: 4,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zxk, {
                            leftIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_io5__WEBPACK_IMPORTED_MODULE_4__/* .IoLogoFacebook */ .egd, {}),
                            colorScheme: "facebook",
                            onClick: handleFacebookShare,
                            flex: 1,
                            children: "Facebook"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zxk, {
                            leftIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_io5__WEBPACK_IMPORTED_MODULE_4__/* .IoLogoWhatsapp */ .ff9, {}),
                            colorScheme: "whatsapp",
                            bg: "#25D366",
                            _hover: {
                                bg: "#128C7E"
                            },
                            onClick: handleWhatsAppShare,
                            flex: 1,
                            children: "WhatsApp"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kCb, {
                    gap: 2,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Input */ .IIB, {
                            value: currentUrl,
                            readOnly: true,
                            placeholder: currentUrl,
                            flex: 1
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zxk, {
                            leftIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_md__WEBPACK_IMPORTED_MODULE_5__/* .MdContentCopy */ .Fqs, {}),
                            onClick: onCopy,
                            colorScheme: hasCopied ? "green" : "gray",
                            children: hasCopied ? "Copied!" : "Copy"
                        })
                    ]
                })
            ]
        })
    });
};


/***/ }),

/***/ 8972:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ SearchPage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8029);
/* harmony import */ var interweave__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9996);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7294);
/* harmony import */ var react_icons_fa__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9583);
/* harmony import */ var _components_SharePopup__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1320);
/* harmony import */ var _containers_Helmet__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(9536);
/* harmony import */ var _layout_Footer__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(3981);
/* harmony import */ var _layout_HeaderV3__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(4850);
/* harmony import */ var _layout_Section__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(1914);
/* harmony import */ var _utils_hooks__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(1127);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}













var UnsafeHeading = _chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Heading */ .X6q;
var UnsafeButton = _chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zxk;
var UnsafeFlex = _chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kCb;
var UnsafeText = _chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xvT;
var __N_SSG = true;
function SearchPage(param) {
    var header = param.header, hotelBrands = param.hotelBrands, sitemapData = param.sitemapData, blog = param.blog;
    var ref, ref1;
    var ref2 = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)(), locale = ref2.locale, query = ref2.query, isReady = ref2.isReady, push = ref2.push;
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(false), isSharePop = ref3[0], setIsSharePop = ref3[1];
    var ref4 = _slicedToArray((0,_utils_hooks__WEBPACK_IMPORTED_MODULE_12__/* .useFetchSWRv2 */ .bX)("blog", {
        cct_status: "publish",
        slug: String(query.bid || blog.slug || "")
    }, {
        refreshInterval: 10000,
        fallbackData: [
            blog
        ],
        revalidateOnMount: true,
        revalidateOnFocus: true,
        dedupingInterval: 0
    }), 1), blogTemp = ref4[0];
    var currentBlog = (blogTemp === null || blogTemp === void 0 ? void 0 : blogTemp[0]) || blog;
    var ref5, ref6;
    // const [itemTemp, isLoading, isError] = useFetchSWRv2(`blog`, {
    //   cct_status: "publish",
    //   _ID: query.id,
    // });
    // useEffect(() => {
    //   if (!isReady) return;
    //   if (!query.id || (!isLoading && !itemTemp)) push("/blog");
    // }, [isLoading, isReady, itemTemp, push, query]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_containers_Helmet__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                title: !(0,lodash__WEBPACK_IMPORTED_MODULE_3__.isEmpty)(currentBlog.meta_title_id) && locale == "id" ? currentBlog.meta_title_id : !(0,lodash__WEBPACK_IMPORTED_MODULE_3__.isEmpty)(currentBlog.meta_title_en) ? currentBlog.meta_title_en : "".concat(currentBlog.title, " - Blog | Parador Hotels & Resorts"),
                description: locale == "id" ? !(0,lodash__WEBPACK_IMPORTED_MODULE_3__.isEmpty)(currentBlog.meta_desc_id) ? currentBlog.meta_desc_id : "" : !(0,lodash__WEBPACK_IMPORTED_MODULE_3__.isEmpty)(currentBlog.meta_desc_en) ? currentBlog.meta_desc_en : "",
                image: !(0,lodash__WEBPACK_IMPORTED_MODULE_3__.isEmpty)(currentBlog.meta_thumb) ? currentBlog.meta_thumb : currentBlog.thumbnail
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_layout_HeaderV3__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                headerItem: header,
                isHomepage: false,
                hotelBrands: hotelBrands
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_layout_Section__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UnsafeHeading, {
                        mb: 2,
                        as: "h1",
                        fontWeight: 400,
                        letterSpacing: "wider",
                        color: header.color_primary,
                        textAlign: "center",
                        children: currentBlog.title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(interweave__WEBPACK_IMPORTED_MODULE_2__/* .Markup */ .Lu, {
                        className: "white-space-enter",
                        content: locale == "id" ? (ref5 = (ref = currentBlog.content_id) === null || ref === void 0 ? void 0 : ref.replace(/\\n/g, "<br>")) !== null && ref5 !== void 0 ? ref5 : "" : (ref6 = (ref1 = currentBlog.content_en) === null || ref1 === void 0 ? void 0 : ref1.replace(/\\n/g, "<br>")) !== null && ref6 !== void 0 ? ref6 : ""
                    }),
                    currentBlog.promo_url != "" && currentBlog.promo_url != null && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Center */ .M5Y, {
                        mt: 4,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xuv, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UnsafeButton, {
                                variant: "dark",
                                onClick: function() {
                                    push(currentBlog.promo_url);
                                },
                                children: locale == "id" ? "Lebih Lanjut" : "Learn More"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xuv, {
                        mt: 6,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UnsafeButton, {
                            variant: "ghost",
                            color: header.color_primary,
                            onClick: function() {
                                return setIsSharePop(true);
                            },
                            px: 0,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(UnsafeFlex, {
                                align: "center",
                                gap: 2,
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_fa__WEBPACK_IMPORTED_MODULE_6__/* .FaShare */ .Lrt, {}),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UnsafeText, {
                                        fontWeight: 600,
                                        children: locale == "id" ? "Bagikan" : "Share"
                                    })
                                ]
                            })
                        })
                    }),
                    isSharePop && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_SharePopup__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        isOpen: isSharePop,
                        onClose: function() {
                            return setIsSharePop(false);
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xuv, {
                h: 10
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_layout_Footer__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                loc: header.location_url,
                address: header.location_long,
                email: header.email,
                phone: header.phone
            })
        ]
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5445,1228,5525,9996,4939,3981,9774,2888,179], function() { return __webpack_exec__(4028); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);